import type { FC } from 'react';
import '../css/pokemonRoulette.css';
import { useDocumentTitle } from '../ts/useDocumentTitle';

const PokemonRoulette: FC = () => {
    useDocumentTitle('Pokémon Roulette');


 return(
    <div className="pokemon-roulette-container">
        {/* Stars background layer */}
        <div className="md-stars" aria-hidden="true"></div>
        <header className="roulette-header">
            <h1>Pokémon Roulette</h1>
        </header>

        <main className="roulette-body">
            <div className="content">
                {/* Main content goes here */}
            </div>
        </main>

        <footer className="roulette-footer">
            <p>&copy; 2026 SideQuest</p>
        </footer>
    </div>
 );
};

export default PokemonRoulette;
